import { parseISOLocal } from './date';
import { isAfter } from 'date-fns';

function getMinDate(config) {
  let fromDate = new Date();
  const minDate =
    config.minDate == null || config.minDate.trim() == ''
      ? null
      : parseISOLocal(config.minDate);
  if (minDate != null && isAfter(minDate, fromDate)) {
    fromDate = minDate;
  }
  return fromDate;
}

export default getMinDate;
